import { useSetRecoilState } from 'recoil'
import { modalOpenState } from '../../atoms/layout'
import Button from '@mui/material/Button'
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

interface Props {
  title: string
  question: string
  onConfirm: () => any
}

export default function AcceptModal({ title, question, onConfirm }: Props) {
  const setModalOpen = useSetRecoilState(modalOpenState)

  return (
    <>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{question}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ gap: 1 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={() => {
            onConfirm()
            setModalOpen(false)
          }}
        >
          بله
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            setModalOpen(false)
          }}
        >
          لغو
        </Button>
      </DialogActions>
    </>
  )
}
